module.exports = __webpack_public_path__ + "img/1783505533006329.0ede4853.webp";